export const activeCampaign = {
    label: "Active",
    value: "active",
};

export const defaultCampaign = {
    label: "Default",
    value: "default",
};
